import React from 'react';
import Logo from './Logo';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-white" aria-label="Rodapé do site">
      {/* Footer Links */}
      <div className="border-t border-gray-200 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center space-x-2 mb-4">
                <Logo />
              </div>
              <p className="text-gray-600 max-w-md">
                O discador web que transforma sua operação com BINA inteligente, monitoria em tempo real e inteligência artificial.
              </p>
              <p className="text-gray-400 text-xs mt-4">
                Onflow é um produto de propriedade da{' '}
                <a 
                  href="https://onmai.com.br" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-gray-600 underline transition-colors"
                >
                  Onmai Innovations
                </a>
              </p>
            </div>

            {/* Product Links */}
            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Produto</h4>
              <ul className="space-y-2 text-gray-600">
                <li><a href="#features" className="hover:text-gray-900 transition-colors">Recursos</a></li>
                <li><a href="#pricing" className="hover:text-gray-900 transition-colors">Preços</a></li>
                <li><a href="#testimonials" className="hover:text-gray-900 transition-colors">Casos de Sucesso</a></li>
              </ul>
            </div>

            {/* Company Links */}
            <div>
              <h4 className="font-semibold text-gray-900 mb-4">Empresa</h4>
              <ul className="space-y-2 text-gray-600">
                <li><a href="https://onmai.com.br/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 transition-colors">Sobre</a></li>
                <li><a href="https://wa.me/+551142101312" target="_blank" rel="noopener noreferrer" className="hover:text-gray-900 transition-colors">Suporte</a></li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-500 text-sm text-center">
              © {currentYear} Onflow. Todos os direitos reservados.
            </div>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a
                href="https://flow.onmai.app.br/politicas-de-privacidade"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-gray-900 text-sm transition-colors"
                tabIndex={0}
                aria-label="Políticas de Privacidade"
              >
                Política de Privacidade
              </a>
              <a
                href="https://flow.onmai.app.br/termos-de-uso"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-gray-900 text-sm transition-colors"
                tabIndex={0}
                aria-label="Termos de Uso"
              >
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
